exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.toolbarSearch[data-v-0bdaa4f8] {\n    border-radius: 8px;\n}\n.centered-input input[data-v-0bdaa4f8] {\n    text-align: center;\n}\n\n", ""]);
